define('app/sf/concat/sf-concat-filter',[],function () {
	return function sfConcat(target, expression) {
		return angular.emptyArray.concat(target || angular.emptyArray, expression || angular.emptyArray);
	};
});
